import { render, staticRenderFns } from "./IcoConicleShort.vue?vue&type=template&id=28ae36c0"
import script from "./IcoConicleShort.vue?vue&type=script&lang=js"
export * from "./IcoConicleShort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports